<template>
  <div class="main main--login main--background">
    <div class="container login">
      <img src="../../assets/img/geberit-logo-1.png" alt="geberit" class="login__logo">
      <form method="post" class="form" v-bind:class="{ pending: pending }" @submit="login">
        <div class="alert alert-danger" role="alert" v-if="error">
          {{ error }}
        </div>
        <div class="form__input-container">
          <input type="text" name="email" v-model="form.email" class="form__input" placeholder="Twój adres e-mail" />
        </div>
        <div class="form__input-container">
          <input type="password" name="password" v-model="form.password" class="form__input" placeholder="Hasło" />
        </div>
        <div class="form__input-container">
          <button type="submit" class="button button--blue form__submit" v-bind:disabled="pending">
            Zaloguj &raquo;
          </button>
        </div>
        <div class="form__input-container login__forget-password">
          <router-link :to="{ name: 'ForgetPassword' }">Przypomnij hasło</router-link>
        </div>
        <div class="form__input-container login__forget-password">
          <router-link :to="{ name: 'Welcome' }">Wróć</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AuthenticationService from '@/app/authentication/authentication.service'

export default {
  name: 'Authentication',
  data() {
    return {
      error: '',
      pending: false,
      form: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    /**
     * Login method.
     *
     * @return {void}
     */
    login: function (e) {
      e.preventDefault();

      let vm = this;
      vm.error = "";
      vm.pending = true;

      AuthenticationService.login(vm.form.email, vm.form.password)
        .then((response) => {
          vm.pending = false;
        })
        .catch((error) => {
          vm.pending = false;
          vm.error = error.response.data.message;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/app/authentication/Authentication.vue